import type {MutableRefObject} from 'react';

export function useDirection(
  containerRef: MutableRefObject<HTMLDivElement | null>
) {
  if (containerRef.current) {
    return window.getComputedStyle(containerRef.current).direction as
      | 'ltr'
      | 'rtl';
  }

  return 'ltr';
}
